import React from 'react';
import roomIconRedLg from '../../../assets/images/roomIconRedLg.png';
import roomIconWhiteLg from '../../../assets/images/roomIconWhiteLg.png';
import statusIconRedLg from '../../../assets/images/statusIconRedLg.png';
import statusIconWhiteLg from '../../../assets/images/statusIconWhiteLg.png';
import confirmIconRedLg from '../../../assets/images/confirmIconRedLg.png';
import confirmIconWhiteLg from '../../../assets/images/confirmIconWhiteLg.png';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../store/langSlice';
import { getLang } from '../../../environnement';

function SteperItem({
  title,
  icon,
  iconActive,
  isActive,
  lang,
}) {
  return (
    <div className='flex flex-col items-center'>
      <div className={`rounded-full border border-primary w-16 h-16 md:w-40 md:h-40 lg:w-60 lg:h-60 flex justify-center items-center ${isActive && 'bg-primary'}`}>
        <img src={icon} alt='itemIcon' className={`w-8 md:w-24 lg:w-32 ${isActive ? 'hidden' : 'inline'}`} />
        <img src={iconActive} alt='itemIcon' className={`w-8 md:w-24 lg:w-32 ${!isActive ? 'hidden' : 'inline'}`} />
      </div>
      <p className='font-medium text-primary text-xl text-center w-44 mt-5 hidden sm:block' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{title}</p>
    </div>
  );
}

export default function Steper({
  step
}) {
  const lang = useSelector(langSelector);

  return (
    <div className='mt-10 xxs:mb-5'>
      <div className='md:flex justify-between items-center pt-5 pb-10 hidden'>
        <SteperItem lang={lang} icon={roomIconRedLg} iconActive={roomIconWhiteLg} title={getLang(lang).reservationSalle.demandeReservationSalle} isActive={step === 1} />
        <span className='text-5xl hidden xxs:block text-primary font-medium relative bottom-2 sm:bottom-10'>...</span>
        <SteperItem lang={lang} icon={statusIconRedLg} iconActive={statusIconWhiteLg} title={getLang(lang).reservationSalle.suivreEtatDemande} isActive={step === 2} />
        <span className='text-5xl hidden xxs:block text-primary font-medium relative bottom-2 sm:bottom-10'>...</span>
        <SteperItem lang={lang} icon={confirmIconRedLg} iconActive={confirmIconWhiteLg} title={getLang(lang).reservationSalle.confirmationDemande} isActive={step === 3} />
      </div>
      <div className='md:hidden'>
        {step === 1 && <p className='text-primary text-2xl xxs:text-3xl font-medium mb-5'>{getLang(lang).reservationSalle.demandeReservationSalle} :</p>}
        {step === 2 && <p className='text-primary text-2xl xxs:text-3xl font-medium mb-5'>{getLang(lang).reservationSalle.suivreEtatDemande} :</p>}
        {step === 3 && <p className='text-primary text-2xl xxs:text-3xl font-medium mb-5'>{getLang(lang).reservationSalle.confirmationDemande} :</p>}
      </div>
    </div>
  );
}
